

export const ContractOfInsurance = () => {
    return (
        <>
         <div className="container-fluid">
            <div className="row px-lg-5 pb-5 p-3" >
                {/* <div className="col-12">
                    <Header actives="Services" />
                    <HerosectionsAll ScreenName="contract of insurance" ScreenSearch="ContractofInsurance" /> */}

                <h2 className="text-center mb-5 mt-4 fw-bold">Contract of Insurance </h2>
                <div className="col-12 col-lg-6 p-4 p-lg-5 bgservices" >
                    <p style={{ textAlign: 'justify' }}>
                        Insurance is a contract between the two parties i.e. the Insurance Company and the Assured and hence all the ordinary rules of the contract that is, offer, acceptance, consideration are applicable to the Insurance contract. Apart from this the insurance contracts are subject to some fundamental principles i.e. Indemnity and Utmost Good faith.
                        To achieve the Indemnity under the insurance contract, further fundamental principles to be observed are, Insurable Interest, Subrogation, Contribution and Refund of Premium.
                        Two further principles which stems from Utmost Good Faith are, Disclosure and   Representation.
                    </p>
                </div>

                <div className="col-12 col-lg-6 px-lg-5 py-3 mt-4 mt-lg-0" style={{ border: '1px solid #a7a7a7' }}>
                    <img src="Static/Assets/Img/contractofinsurance.jpg" className="contractofinsurance1" alt="" srcset="" />
                </div>
            </div>
</div>
            {/* <div className="col-12 p-lg-5 pb-4" >
                <img src="Static/Assets/Img/edifice3-01.jpg" className="contractofinsurance2 mx-auto" alt="" srcset="" />
            </div> */}

            {/* </div>
            </div> */}
        </>
    )
}
